import React from 'react';
import { Dumbbell, Zap } from 'lucide-react';
import { DashboardWidget } from './DashboardWidget';
import { useOptimizedDashboardData } from '@/hooks/useOptimizedDashboardData';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

export const OptimizedGeneralFitnessCoachTeaser: React.FC = React.memo(() => {
  const { fitnessCoachData, fitnessCoachLoading } = useOptimizedDashboardData();

  if (fitnessCoachLoading) {
    return (
      <Card className="h-full animate-pulse">
        <CardHeader>
          <Skeleton className="h-6 w-3/4" />
          <Skeleton className="h-4 w-1/2" />
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-3/4" />
            <Skeleton className="h-10 w-full" />
          </div>
        </CardContent>
      </Card>
    );
  }

  if (!fitnessCoachData) return null;

  const activityTypesCount = fitnessCoachData.recentActivities.length > 0 ? 
    [...new Set(fitnessCoachData.recentActivities.map(a => a.type))].length : 0;

  const badges = [
    'Cross-Training',
    ...(activityTypesCount > 0 ? [`${activityTypesCount} Types`] : [])
  ];

  return (
    <DashboardWidget
      title="AI Fitness Coach"
      description="Comprehensive fitness coaching across all activities"
      icon={Dumbbell}
      primaryColor="accent"
      ctaText="Get Fitness Coaching"
      ctaLink="/ai-coach-fitness"
      data={fitnessCoachData}
      badges={badges}
    />
  );
});